<c-row class="g-4">
  @for (widget of brandData; track widget; let i = $index) {
    <c-col sm="6" xl="3">
      <c-widget-stat-d
        [color]="widget.color ?? ''"
        [style]="widget.capBg ?? null"
        [values]="widget.values"
      >
        <svg [name]="widget.icon" cIcon class="my-4 text-white" height="52"></svg>
        @if (withCharts()) {
          <c-chart
            #chart="cChart"
            [data]="widget.data"
            [options]="chartOptions"
            class="position-absolute w-100 h-100"
            type="line"
          >
            {{ chart.id }}
          </c-chart>
        }
      </c-widget-stat-d>
    </c-col>
  }
</c-row>
